import { Button, Card, Space } from "antd";
import { ReactNode, useEffect } from "react";
import CustomModal from "../../../../components/ui/CustomModal";
import { useDeleteUserPoolMutation } from "../../../../features/portal/Products/productsApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";

export interface ModalConfirmProps<
  DataT = never,
  TypeT =
    | "SUCCESS"
    | "ADD"
    | "UPDATE"
    | "VIEW"
    | "CONFIRM"
    | "CONFIRM_FOR_APPROVAL"
> {
  open: boolean;
  action?: boolean;
  buttonBgDeep?: boolean;
  handleClose: (val?: any) => void;
  type?: TypeT;
  data?: any;
  title?: ReactNode;
  subTitle?: ReactNode;
  buttonName?: string;
  loading?: boolean;
  children?: ReactNode;
}

export default function UserPollDeleteModal({
  title,
  action,
  buttonName,
  buttonBgDeep,
  subTitle,
  handleClose,
  children,
  type,
  data,
  loading,
  ...rest
}: ModalConfirmProps) {
  // const [form] = Form.useForm();
  // const onFinish = (values: any) => {};
  const [deleteUserPool, { isError, error, isLoading, isSuccess }] =
    useDeleteUserPoolMutation();
  useError(isError, error, "Password reset fail");

  const handlePollRemove = () => {
    const newData = {
      // id: Number(data?.pool?.id),
      id: Number(data?.id),
    };
    deleteUserPool(newData);
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      toast("success", "Pool removed successfully");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={400}
        footer={null}
      >
        <Card className="w-full">
          <h4 className=" font-semibold text-[18px] text-[#5E718D] text-center">
            Poll Remove
          </h4>

          <div className=" font-normal text-[14px] text-[#5E718D] text-center">
            Are you sure you want to remove this poll?
          </div>

          <Space className="flex gap-2 mt-6">
            <Button
              className="normal-dark-button modal-button"
              size="middle"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
              onClick={handlePollRemove}
              loading={isLoading}
            >
              Remove
            </Button>
          </Space>

          {/* <Form
            className="custom-form"
            layout="vertical"
            requiredMark="optional"
            size="large"
            onFinish={onFinish}
            form={form}
          >
            <Form.Item
              name="New Password"
              label="New Password"
              className="mb-[18px] mt-3"
              rules={[
                {
                  required: true,
                  message: "Please enter your new password",
                },
              ]}
            >
              <Input.Password prefix={<LockIcon />} placeholder="Password" />
            </Form.Item>

            <Form.Item
              name="Confirm New Password"
              label="Confirm New Password"
              className="mb-[18px] mt-3"
              rules={[
                {
                  required: true,
                  message: "Please enter your confirm new password",
                },
              ]}
            >
              <Input.Password prefix={<LockIcon />} placeholder="Password" />
            </Form.Item>

            <Space className="flex gap-2 mt-6">
              <Button
                className="normal-dark-button modal-button"
                size="middle"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                //   loading={isLoading || isUpdateLoading}
              >
                Password Reset
              </Button>
            </Space>
          </Form> */}
        </Card>
      </CustomModal>
    </>
  );
}
